module.exports = {
  buildTargetMetatag(key, val) {
    const metatag = document.createElement('meta');
    metatag.setAttribute('name', 'ai-dfp-target');
    metatag.setAttribute('data-key', key);
    metatag.setAttribute('data-val', val);
    return metatag;
  },

  rebuildTargeting(targets) {
    if (!targets) {
      return;
    }
    let placementMetatag = Array.from(
      document.querySelectorAll('meta[name=ai-slot]')
    ).slice(-1)[0];
    const targetMetatags = Array.from(
      document.querySelectorAll('meta[name=ai-dfp-target]')
    );
    for (const targetMetatag of targetMetatags) {
      targetMetatag.remove();
    }
    window.googletag.pubads().clearTargeting();
    for (const target of targets) {
      placementMetatag = placementMetatag.insertAdjacentElement(
        'afterEnd',
        this.buildTargetMetatag(target.key, target.val)
      );
      window.googletag.pubads().setTargeting(target.key, target.val);
    }
  },

  refresh(hash) {
    if (!hash || !(window.googletag && window.googletag.pubads)) {
      return;
    }
    this.rebuildTargeting(
      hash.aiHeader != null ? hash.aiHeader.dfpTargets : undefined
    );
    window.googletag.pubads().refresh();
  },

  insertMobileAds(positions, oldCards, newCards, presentedAiAds) {
    if (!presentedAiAds) {
      return [];
    }
    if (positions[0] >= positions[1]) {
      return [];
    }
    const insertedAds = [];
    if (
      oldCards.length < positions[0] &&
      (newCards && positions[0] <= newCards.length)
    ) {
      insertedAds.push(presentedAiAds[0].apif);
      newCards.splice(positions[0], 0, presentedAiAds[0]);
    }
    if (
      oldCards.length < positions[1] + 1 &&
      (newCards && positions[1] + 1 <= newCards.length)
    ) {
      insertedAds.push(presentedAiAds[1].apif);
      newCards.splice(positions[1] + 1, 0, presentedAiAds[1]);
    }
    return insertedAds;
  },
};
